// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__6v1QQ","errors":"Errors_errors__RcZPw"};